// extracted by mini-css-extract-plugin
export default {"srOnly":"zwDSS"};